module.exports = __webpack_public_path__ + "fonts/proxima_nova_regular-webfont.18f00245.woff";